var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ready-to-launch" }, [
    _c(
      "ul",
      { staticClass: "nav nav-tabs", staticStyle: { "margin-bottom": "25px" } },
      [
        _vm._m(0),
        _vm._m(1),
        _vm._m(2),
        !_vm.isMixCampaign
          ? _c("li", [
              _c("a", { attrs: { "data-toggle": "tab", href: "#activity" } }, [
                _vm._v("Activity")
              ])
            ])
          : _vm._e(),
        _vm.isMixCampaign && _vm.hasWatchActivity
          ? _c("li", [
              _c("a", { attrs: { "data-toggle": "tab", href: "#mix-video" } }, [
                _vm._v("Video")
              ])
            ])
          : _vm._e(),
        _vm.isMixCampaign && _vm.hasProductPhotos
          ? _c("li", [
              _c(
                "a",
                {
                  attrs: { "data-toggle": "tab", href: "#mix-product-photos" }
                },
                [_vm._v("Product Photos")]
              )
            ])
          : _vm._e(),
        !_vm.isMixCampaign || _vm.hasSurveyActivity
          ? _c("li", [
              _c(
                "a",
                { attrs: { "data-toggle": "tab", href: "#survey-insight" } },
                [
                  _vm._v(
                    _vm._s(_vm.isMixCampaign ? "Survey" : "Survey Insight")
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._m(3)
      ]
    ),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "tab-content" }, [
          _c(
            "div",
            {
              staticClass: "campaign-overview tab-pane fade in active",
              attrs: { id: "campaign-overview" }
            },
            [
              _c("h3", [_vm._v("Campaign Overview")]),
              _c("div", { staticClass: "campaign-overview-list" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("h4", [_vm._v("Campaign Name")]),
                        _c("h6", [
                          _vm._v(_vm._s(_vm.getCampaignDetail.campaign_name))
                        ]),
                        _c("h4", [_vm._v("Num of Activities")]),
                        _c("h6", [
                          _vm._v(
                            _vm._s(_vm.getCampaignDetail.total_activity_count)
                          )
                        ]),
                        _c("h4", [_vm._v("Start Date")]),
                        _c("h6", [
                          _vm._v(_vm._s(_vm.getCampaignDetail.start_date))
                        ]),
                        _c("h4", [_vm._v("Unlock Code")]),
                        _c("h6", [
                          _vm._v(_vm._s(_vm.getCampaignDetail.unlock_code))
                        ]),
                        _c("h4", [_vm._v("Buy Me Activity")]),
                        _c("h6", [_vm._v("Not available for freemium")]),
                        _c("h4", [_vm._v("Budget")]),
                        _c("h6", [
                          _vm._v(_vm._s(_vm.getCampaignDetail.campaign_budget))
                        ])
                      ]),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("h4", [_vm._v("Location Type")]),
                        _vm.getCampaignDetail.geo_location_type ==
                        "any-user-location"
                          ? _c("h6", [_vm._v("Anywhere (Audience's Choice)")])
                          : _vm._e(),
                        _vm.getCampaignDetail.geo_location_type ==
                        "any-physical-location"
                          ? _c("h6", [
                              _vm._v("Custom Location (Flexible Address)")
                            ])
                          : _vm._e(),
                        _c("h4", [_vm._v("Single User Limit")]),
                        _c("h6", [
                          _vm._v(
                            _vm._s(_vm.getCampaignDetail.single_user_limit)
                          )
                        ]),
                        _c("h4", [_vm._v("End Date")]),
                        _c("h6", { staticStyle: { "min-height": "15.9px" } }, [
                          _vm._v(_vm._s(_vm.getCampaignDetail.end_date))
                        ]),
                        _c("h4", [_vm._v("Plan")]),
                        _c("h6", [
                          _vm._v(_vm._s(_vm.getCampaignDetail.package))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]
          ),
          !_vm.isMixCampaign &&
          _vm.getCampaignDetail &&
          _vm.getCampaignDetail.id
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "activity" }
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "margin-bottom": "20px"
                      }
                    },
                    [_vm._v("Activity Details")]
                  ),
                  _vm.getCampaignDetail.geo_location_type == "any-user-location"
                    ? _c("div", [
                        _c("h4", [_vm._v(" " + _vm._s(_vm.media.title) + " ")]),
                        _c("iframe", {
                          attrs: {
                            width: "100%",
                            height: "300px",
                            src: "https://www.youtube.com/embed/" + _vm.videoId,
                            title: "YouTube video player",
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            referrerpolicy: "strict-origin-when-cross-origin",
                            allowfullscreen: ""
                          }
                        }),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "margin-top": "10px",
                              "font-size": "20px",
                              "margin-bottom": "15px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.media.brand_intro))]
                        ),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "margin-bottom": "15px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.media.description))]
                        ),
                        _vm.media.have_app_links == "1"
                          ? _c("div", [
                              _c(
                                "h5",
                                {
                                  staticStyle: {
                                    "font-size": "17px",
                                    color: "#000"
                                  }
                                },
                                [
                                  _vm._v(
                                    "App Name: " + _vm._s(_vm.media.app_name)
                                  )
                                ]
                              ),
                              _vm.media.android_app_link
                                ? _c(
                                    "h6",
                                    { staticStyle: { "font-size": "15px" } },
                                    [
                                      _vm._v(
                                        "Android App Link: " +
                                          _vm._s(_vm.media.android_app_link)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.media.ios_app_link
                                ? _c(
                                    "h6",
                                    { staticStyle: { "font-size": "15px" } },
                                    [
                                      _vm._v(
                                        "IOS App Link: " +
                                          _vm._s(_vm.media.ios_app_link)
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm.media.have_web_links == "1"
                          ? _c("div", [
                              _c("h5", [
                                _vm._v(
                                  "Website Name: " + _vm._s(_vm.media.app_name)
                                )
                              ]),
                              _vm.media.android_app_link
                                ? _c(
                                    "h6",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        color: "#000",
                                        "margin-top": "15px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Website Link: " +
                                          _vm._s(_vm.media.website_url)
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.media.media_images, function(mediaImg) {
                            return _c(
                              "div",
                              { key: mediaImg.image, staticClass: "col-md-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mediaBox",
                                    staticStyle: { "margin-top": "20px" }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: { src: mediaImg.image }
                                    }),
                                    _c("h4", [
                                      _vm._v(_vm._s(mediaImg.description))
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _c("div", [
                        _c("h4", [
                          _vm._v(
                            "Guide Page: " + _vm._s(_vm.getProductDetail.name)
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.getImages, function(getImag) {
                            return _c(
                              "div",
                              {
                                key: getImag.img,
                                staticClass: "col-md-3",
                                staticStyle: { "margin-top": "15px" }
                              },
                              [
                                _c("img", {
                                  staticStyle: { "max-width": "100%" },
                                  attrs: { src: getImag.img }
                                }),
                                _c("h5", [_vm._v(_vm._s(getImag.description))])
                              ]
                            )
                          }),
                          0
                        ),
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "font-size": "17px",
                              color: "#000",
                              "margin-bottom": "5px",
                              "font-weight": "500"
                            }
                          },
                          [_vm._v("Description")]
                        ),
                        _c("p", [
                          _vm._v(_vm._s(_vm.getProductDetail.description))
                        ]),
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "font-size": "17px",
                              color: "#000",
                              "font-weight": "500"
                            }
                          },
                          [_vm._v("Visual Prompt")]
                        ),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.getTasks, function(task) {
                            return _c(
                              "div",
                              { key: task.name, staticClass: "col-md-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "taskBox",
                                    staticStyle: { "margin-top": "15px" }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: { src: task.img }
                                    }),
                                    _c("h5", [_vm._v(_vm._s(task.name))])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                ]
              )
            : _vm._e(),
          _vm.isMixCampaign && _vm.hasWatchActivity
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "mix-video" }
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "margin-bottom": "20px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.watchActivity.activity_label || "Video")
                      )
                    ]
                  ),
                  _vm.watchVideoId
                    ? _c("iframe", {
                        attrs: {
                          width: "100%",
                          height: "300px",
                          src:
                            "https://www.youtube.com/embed/" + _vm.watchVideoId,
                          title: "YouTube video player",
                          frameborder: "0",
                          allow:
                            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                          referrerpolicy: "strict-origin-when-cross-origin",
                          allowfullscreen: ""
                        }
                      })
                    : _c("p", { staticStyle: { "text-align": "left" } }, [
                        _vm._v("No video link available")
                      ]),
                  _c(
                    "h6",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        color: "#000",
                        margin: "15px 0 5px",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v("Description")]
                  ),
                  _c("p", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.watchActivity.description ||
                          (_vm.watchActivity.link &&
                            _vm.watchActivity.link.description) ||
                          ""
                      )
                    )
                  ]),
                  _vm.watchActivity.link && _vm.watchActivity.link.website_link
                    ? _c(
                        "h6",
                        {
                          staticStyle: {
                            "font-size": "15px",
                            color: "#000",
                            "margin-top": "10px"
                          }
                        },
                        [
                          _vm._v("\n          Link: "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.watchActivity.link.website_link,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.watchActivity.link.website_link)
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm.isMixCampaign && _vm.hasProductPhotos
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "mix-product-photos" }
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "margin-bottom": "20px"
                      }
                    },
                    [_vm._v("Product Photos")]
                  ),
                  _vm.productActivity &&
                  _vm.productActivity.products &&
                  _vm.productActivity.products.length
                    ? _c(
                        "div",
                        _vm._l(_vm.productActivity.products, function(
                          product,
                          pIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: product.product_id || pIndex,
                              staticStyle: { "margin-bottom": "25px" }
                            },
                            [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(
                                    product.name || "Product " + (pIndex + 1)
                                  )
                                )
                              ]),
                              _c("div", { staticClass: "row" }, [
                                product.img
                                  ? _c("div", { staticClass: "col-md-3" }, [
                                      _c("img", {
                                        staticStyle: { "max-width": "100%" },
                                        attrs: { src: product.img }
                                      }),
                                      _c("h5", [_vm._v("Product")])
                                    ])
                                  : _vm._e()
                              ]),
                              product.description
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "text-align": "left",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [_vm._v(_vm._s(product.description))]
                                  )
                                : _vm._e(),
                              _c(
                                "h6",
                                {
                                  staticStyle: {
                                    "font-size": "17px",
                                    color: "#000",
                                    "font-weight": "500",
                                    "margin-top": "15px"
                                  }
                                },
                                [_vm._v("Visual Prompt")]
                              ),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(product.tasks || [], function(task) {
                                  return _c(
                                    "div",
                                    {
                                      key: "p-task-" + task.id,
                                      staticClass: "col-md-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "taskBox",
                                          staticStyle: { "margin-top": "15px" }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "max-width": "100%"
                                            },
                                            attrs: { src: task.img }
                                          }),
                                          _c("h5", [_vm._v(_vm._s(task.name))])
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.photoActivity && _vm.mixPhotoTasks.length
                    ? _c("div", [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.photoActivity.activity_label ||
                                "Photo Activity"
                            )
                          )
                        ]),
                        _vm.photoActivity.description
                          ? _c("p", { staticStyle: { "text-align": "left" } }, [
                              _vm._v(_vm._s(_vm.photoActivity.description))
                            ])
                          : _vm._e(),
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "font-size": "17px",
                              color: "#000",
                              "font-weight": "500",
                              "margin-top": "15px"
                            }
                          },
                          [_vm._v("Visual Prompt")]
                        ),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.mixPhotoTasks, function(task) {
                            return _c(
                              "div",
                              {
                                key: "photo-task-" + task.id,
                                staticClass: "col-md-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "taskBox",
                                    staticStyle: { "margin-top": "15px" }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: { src: task.img }
                                    }),
                                    _c("h5", [_vm._v(_vm._s(task.name))])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm.productActivity &&
                  (!_vm.productActivity.products ||
                    !_vm.productActivity.products.length) &&
                  _vm.mixProductTasks.length
                    ? _c("div", [
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "font-size": "17px",
                              color: "#000",
                              "font-weight": "500"
                            }
                          },
                          [_vm._v("Visual Prompt")]
                        ),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.mixProductTasks, function(task) {
                            return _c(
                              "div",
                              {
                                key: "mix-task-" + task.id,
                                staticClass: "col-md-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "taskBox",
                                    staticStyle: { "margin-top": "15px" }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: { src: task.img }
                                    }),
                                    _c("h5", [_vm._v(_vm._s(task.name))])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm.getCampaignDetail && _vm.getCampaignDetail.id
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "location-overview" }
                },
                [
                  _c("h3", [_vm._v("Location Overview")]),
                  _c("div", { staticClass: "campaign-overview-list" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-6" },
                            [
                              _c("h4", [_vm._v("Single User Limit")]),
                              _c("h6", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getCampaignDetail.single_user_limit
                                  )
                                )
                              ]),
                              _c("h4", [_vm._v("# of Countries")]),
                              _c("h6", [_vm._v("1")]),
                              _c("h4", [_vm._v("Launch Areas")]),
                              _c("ChartTemp", {
                                attrs: {
                                  codes: _vm.getSelStates,
                                  retailerImage: _vm.getStoreDetail.img
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h4", [_vm._v("Total Activity Count")]),
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.getCampaignDetail.total_activity_count
                                )
                              )
                            ]),
                            _c("h4", [_vm._v("# of States")]),
                            _c("h6", [
                              _vm._v(_vm._s(_vm.getAudienceCount.StateCount))
                            ]),
                            _vm.getCampaignDetail.geo_location_type ==
                            "any-physical-location"
                              ? _c("h4", [_vm._v("Location")])
                              : _vm._e(),
                            _c("img", {
                              staticStyle: { "max-width": "50%" },
                              attrs: { src: _vm.getStoreDetail.img }
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm.getCampaignDetail && _vm.getCampaignDetail.id
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "audience-overview" }
                },
                [
                  _c("h3", [_vm._v("Audience Overview")]),
                  _c("div", { staticClass: "campaign-overview-list" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _vm.getCampaignDetail.unlock_code == ""
                          ? _c(
                              "h6",
                              {
                                staticStyle: {
                                  "margin-bottom": "3px",
                                  color: "blue",
                                  "margin-top": "0px",
                                  "font-size": "15px"
                                }
                              },
                              [
                                _c("b", { staticStyle: { color: "#000" } }, [
                                  _vm._v("Deep Link:")
                                ]),
                                _vm._v(
                                  " https://api.pickl.pro/pickl/" +
                                    _vm._s(_vm.getCampaignDetail.id)
                                )
                              ]
                            )
                          : _c(
                              "h6",
                              {
                                staticStyle: {
                                  "margin-bottom": "3px",
                                  color: "blue",
                                  "margin-top": "0px",
                                  "font-size": "15px"
                                }
                              },
                              [
                                _c("b", { staticStyle: { color: "#000" } }, [
                                  _vm._v("Deep Link:")
                                ]),
                                _vm._v(
                                  " https://api.pickl.pro/pickl/unlock/" +
                                    _vm._s(_vm.getCampaignDetail.unlock_code)
                                )
                              ]
                            ),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h4", [_vm._v("# of Audiences")]),
                            _c("h6", [
                              _vm._v(_vm._s(_vm.getAudienceCount.AudienceCount))
                            ]),
                            _c("h4", [_vm._v("# of Phone Numbers")]),
                            _c("h6", [
                              _vm._v(_vm._s(_vm.getAudienceCount.AudienceCount))
                            ]),
                            _c("div", { staticStyle: { clear: "both" } }),
                            _vm._m(4)
                          ]),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("h4", [_vm._v("# of Emails")]),
                            _c("h6", [
                              _vm._v(_vm._s(_vm.getAudienceCount.AudienceCount))
                            ])
                          ]),
                          _vm.getAudienceCount.AudienceCount
                            ? _c("div", { staticClass: "col-md-12" }, [
                                _c("h4", [_vm._v("Audiences List Uploaded")]),
                                _c("div", { staticClass: "upload_zip" }, [
                                  _c("img", {
                                    staticClass: "zip_up",
                                    attrs: { src: "/img/zip_up.png" }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.getAudienceCount
                                            .audience_file_name,
                                        download: ""
                                      }
                                    },
                                    [_vm._v("Download ")]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm.getCampaignDetail &&
          _vm.getCampaignDetail.id &&
          (!_vm.isMixCampaign || _vm.hasSurveyActivity)
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "survey-insight" }
                },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.isMixCampaign ? "Survey" : "Survey Insight")
                    )
                  ]),
                  _c("div", { staticClass: "campaign-overview-list" }, [
                    _vm.isMixCampaign &&
                    _vm.surveyActivity &&
                    _vm.surveyActivity.survey
                      ? _c(
                          "div",
                          { staticStyle: { "margin-bottom": "20px" } },
                          [
                            _c("h4", [
                              _vm._v(
                                _vm._s(
                                  _vm.surveyActivity.survey.title ||
                                    _vm.surveyActivity.activity_label
                                )
                              )
                            ]),
                            _vm.surveyActivity.survey.type
                              ? _c("h6", [
                                  _vm._v(
                                    "Type: " +
                                      _vm._s(_vm.surveyActivity.survey.type)
                                  )
                                ])
                              : _vm._e(),
                            _vm.surveyActivity.survey.questions_count != null
                              ? _c("h6", [
                                  _vm._v(
                                    "Questions: " +
                                      _vm._s(
                                        _vm.surveyActivity.survey
                                          .questions_count
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm.surveyActivity.description
                              ? _c(
                                  "p",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.surveyActivity.description)
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm.surveyQuestionsList.length
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.surveyQuestionsList, function(
                            question,
                            qIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: question.id || qIndex,
                                staticClass: "col-md-6"
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticStyle: {
                                      color: "#000",
                                      "font-size": "18px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          question.question ||
                                            question.question_text ||
                                            question.title ||
                                            "Question " + (qIndex + 1)
                                        ) +
                                        "\n                "
                                    ),
                                    question.question_type || question.type
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "14px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  question.question_type ||
                                                    question.type
                                                ) +
                                                ")\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm.getSurveyAnswers(question).length
                                  ? _c(
                                      "ul",
                                      {
                                        staticStyle: { "padding-left": "18px" }
                                      },
                                      _vm._l(
                                        _vm.getSurveyAnswers(question),
                                        function(ans, aIndex) {
                                          return _c(
                                            "li",
                                            { key: ans.id || aIndex },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    ans.answer ||
                                                      ans.option ||
                                                      ans.text ||
                                                      ans
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm.isMixCampaign && _vm.hasSurveyActivity
                      ? _c("p", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(
                            "\n            Survey activity is configured for this campaign.\n          "
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _vm.getCampaignDetail && _vm.getCampaignDetail.id
            ? _c(
                "div",
                {
                  staticClass: "campaign-overview tab-pane fade",
                  attrs: { id: "incentives" }
                },
                [
                  _c("h3", [_vm._v("Incentives")]),
                  _c("div", { staticClass: "campaign-overview-list" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.getCampaignDetail.coupon))]),
                    _c(
                      "h6",
                      {
                        staticStyle: {
                          "margin-bottom": "10px",
                          color: "blue",
                          "margin-top": "1px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getCampaignDetail.link))]
                    ),
                    _c("p", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.description))
                    ]),
                    _c("img", {
                      staticStyle: { "max-width": "50%" },
                      attrs: { src: _vm.getCampaignDetail.coupon_image }
                    })
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _vm.showProductPreview
          ? _c(
              "div",
              {
                class: [
                  "preview NewPrevAct",
                  { "scrolled-fix": _vm.isScrolled }
                ]
              },
              [
                _c("div", { staticClass: "store_brand" }, [
                  _c("img", {
                    staticClass: "left_brand",
                    attrs: { src: _vm.getStoreDetail.img }
                  }),
                  _c("h6", [_vm._v(_vm._s(_vm.brandInfo.name))]),
                  _c("img", {
                    staticClass: "right_brand",
                    attrs: { src: _vm.brandInfo.logo }
                  })
                ]),
                _c(
                  "div",
                  { staticClass: "mapBox" },
                  [
                    _c("h5", [
                      _vm._v('"' + _vm._s(_vm.getStoreDetail.name) + '"')
                    ]),
                    _c("h6", [
                      _vm._v(
                        "Category: " + _vm._s(_vm.previewProductDetail.name)
                      )
                    ]),
                    _c("ChartTemp", {
                      attrs: {
                        codes: _vm.getSelStates,
                        retailerImage: _vm.getStoreDetail.img
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "brand_intro" }, [
                  _c("div", { staticClass: "brand_desc" }, [
                    _c(
                      "div",
                      {
                        staticClass: "brand_header",
                        staticStyle: { float: "left" }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.previewProductDetail.img }
                        }),
                        _c(
                          "h6",
                          {
                            staticStyle: {
                              "text-align": "left",
                              color: "#000",
                              "font-size": "15px",
                              "font-weight": "500"
                            }
                          },
                          [_vm._v(_vm._s(_vm.previewProductDetail.name))]
                        ),
                        _c("p", { staticStyle: { "text-align": "left" } }, [
                          _vm._v(_vm._s(_vm.previewProductDetail.description))
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          "font-size": "14px",
                          color: "#000",
                          "text-align": "left",
                          float: "left",
                          width: "100%",
                          "margin-bottom": "7px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.mixTasks.length
                              ? "Activities"
                              : "Image Requirements"
                          )
                        )
                      ]
                    ),
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "max-height": "210px",
                          overflow: "hidden",
                          "padding-left": "6px",
                          "list-style": "none"
                        }
                      },
                      _vm._l(_vm.previewTasks, function(task, index) {
                        return _c(
                          "li",
                          {
                            key: task.id || index,
                            staticStyle: {
                              "font-size": "14px",
                              "margin-bottom": "6px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.getTaskDisplayName(task)))]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          : _vm.showVideoPreview
          ? _c(
              "div",
              {
                class: [
                  "preview cr_page newPrev",
                  { "scrolled-fix": _vm.isScrolled }
                ]
              },
              [
                _c("div", { staticClass: "logoHeadBox" }, [
                  _c("div", { staticClass: "newPrevLogo" }, [
                    _c("img", {
                      staticStyle: {
                        "max-width": "100%",
                        "border-radius": "50%"
                      },
                      attrs: { src: _vm.brandInfo.logo }
                    })
                  ]),
                  _c("div", { staticClass: "newPrevHead" }, [
                    _vm._v(" " + _vm._s(_vm.brandInfo.name) + " ")
                  ])
                ]),
                _c("div", { staticClass: "yourVideo" }, [
                  !_vm.previewVideoId
                    ? _c("h5", [_vm._v("Your Video")])
                    : _c("span", [
                        _c("iframe", {
                          attrs: {
                            width: "100%",
                            height: "120px",
                            src:
                              "https://www.youtube.com/embed/" +
                              _vm.previewVideoId,
                            title: "YouTube video player",
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            referrerpolicy: "strict-origin-when-cross-origin",
                            allowfullscreen: ""
                          }
                        })
                      ])
                ]),
                _c("div", { staticClass: "mediaDesc" }, [
                  _c("h4", [_vm._v("Description")]),
                  _c("p", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.previewMediaDescription))
                  ])
                ]),
                _vm.mixTasks.length
                  ? _c("div", { staticClass: "mixTaskList" }, [
                      _c("h4", [_vm._v("Activities")]),
                      _c(
                        "ul",
                        _vm._l(_vm.mixTasks, function(activity, index) {
                          return _c("li", { key: activity.id || index }, [
                            _vm._v(_vm._s(_vm.getTaskDisplayName(activity)))
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "active" }, [
      _c("a", { attrs: { "data-toggle": "tab", href: "#campaign-overview" } }, [
        _vm._v("Campaign Overview")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { "data-toggle": "tab", href: "#location-overview" } }, [
        _vm._v("Location Overview")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { "data-toggle": "tab", href: "#audience-overview" } }, [
        _vm._v("Audience Overview")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { "data-toggle": "tab", href: "#incentives" } }, [
        _vm._v("Incentives")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { position: "relative" } }, [
      _c(
        "label",
        { staticClass: "switch", staticStyle: { "z-index": "9", top: "0px" } },
        [
          _c("input", { attrs: { type: "checkbox", checked: "", value: "1" } }),
          _c("span", { staticClass: "slider round" })
        ]
      ),
      _c(
        "label",
        {
          staticStyle: {
            "margin-left": "0px",
            color: "#000",
            "font-weight": "500"
          }
        },
        [_vm._v("Engage PICKL's Audience")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }